import type { ActivityAudience, ActivityItem } from "@/types/activity";

const now = new Date();
const daysAgo = (n: number) => new Date(now.getFullYear(), now.getMonth(), now.getDate() - n, 10, 15, 0);

export const mockActivities: ActivityItem[] = [
    // SHIPPER — Nuova richiesta spedizione via email con allegati e CTA crea container
    {
        id: "a1",
        audience: "shipper",
        type: "email_new_shipment_request",
        title: "Nuova richiesta spedizione da cliente (email automatizzata)",
        description:
            "Richiesta per spedizione commodity: Componenti elettronici. Route: New York → London. Spedizioniere: MSC.",
        timestamp: daysAgo(0),
        isRead: false,
        actor: { name: "Inbound Mailbot" },
        attachments: [
            { name: "bill_of_lading.pdf", type: "pdf", sizeKB: 820 },
            { name: "packing_list.xls", type: "xls", sizeKB: 340 },
            { name: "phyto_certificate.pdf", type: "pdf", sizeKB: 560 },
        ],
        actions: [
            {
                label: "Crea container precompilato",
                href: "/shipper/containers/new?routeFrom=New%20York%2C%20USA&routeTo=London%2C%20UK&shippingCompany=MSC&commodity=Componenti%20elettronici",
            },
        ],
        metadata: {
            routeFrom: "New York, USA",
            routeTo: "London, UK",
            shippingCompany: "MSC",
            commodity: "Componenti elettronici",
        },
    },

    // SHIPPER — Documento aggiornato per container esistente
    {
        id: "a2",
        audience: "shipper",
        type: "document_updated",
        title: "Documento aggiornato: Waybill per container TCLU1234567",
        description: "È stato ricevuto un waybill aggiornato. Verifica e associa ai documenti del container.",
        timestamp: daysAgo(0),
        isRead: false,
        actions: [
            { label: "Apri Documenti", href: "/shipper/containers/1?tab=documents" },
        ],
        metadata: { containerId: "1", containerNumber: "TCLU1234567", documentId: "11", documentType: "waybill" },
    },

    // SHIPPER — Avanzamento stato e Problematica doganale
    {
        id: "a3",
        audience: "shipper",
        type: "status_update",
        title: "Stato aggiornato: Container TCLU1234568 è arrivato al porto di Amsterdam",
        description: "Stato corrente: At Port. Prossimo step: sdoganamento.",
        timestamp: daysAgo(1),
        isRead: true,
        actions: [{ label: "Vedi timeline", href: "/shipper/containers/2?tab=timeline" }],
        metadata: { containerId: "2", containerNumber: "TCLU1234568" },
    },
    {
        id: "a4",
        audience: "shipper",
        type: "customs_issue",
        title: "Dogana: Richiesto controllo aggiuntivo per container SPCA1234568",
        description: "Documentazione incompleta rilevata in dogana. Azione richiesta: integrazione documenti.",
        timestamp: daysAgo(2),
        isRead: true,
        actions: [{ label: "Apri container", href: "/shipper/containers/7?tab=documents" }],
        metadata: { containerId: "7", containerNumber: "SPCA1234568" },
    },
    {
        id: "a5",
        audience: "shipper",
        type: "seal_change",
        title: "Cambio sigillo registrato su container TCLU1234569",
        description: "Nuovo Seal ID: SEAL-99231. Verifica e conferma.",
        timestamp: daysAgo(2),
        isRead: true,
        actions: [{ label: "Dettagli container", href: "/shipper/containers/5" }],
        metadata: { containerId: "5", containerNumber: "TCLU1234569", sealId: "SEAL-99231" },
    },

    // RECEIVER — Avanzamenti stato
    {
        id: "r1",
        audience: "receiver",
        type: "status_update",
        title: "Stato aggiornato: Container TCLU1234567 in transito (75%)",
        description: "Progresso aggiornato, ETA: 15 Feb 2024.",
        timestamp: daysAgo(0),
        isRead: false,
        actions: [{ label: "Vedi timeline", href: "/receiver/containers/1?tab=timeline" }],
        metadata: { containerId: "1", containerNumber: "TCLU1234567" },
    },
    {
        id: "r2",
        audience: "receiver",
        type: "status_update",
        title: "Stato aggiornato: Container IHDE1234567 consegnato",
        description: "Consegna completata. Aggiorna esito.",
        timestamp: daysAgo(1),
        isRead: true,
        actions: [{ label: "Dettagli container", href: "/receiver/containers/3" }],
        metadata: { containerId: "3", containerNumber: "IHDE1234567" },
    },

    // RECEIVER — Invito a risoluzione con CTA a document-review
    {
        id: "r3",
        audience: "receiver",
        type: "resolution_invite",
        title: "Invito alla risoluzione: Discrepanze su documento per container TCLU1234568",
        description: "È richiesta revisione del documento (waybill).",
        timestamp: daysAgo(1),
        isRead: false,
        actions: [
            { label: "Apri Document Review", href: "/receiver/containers/2/documents/11/review" },
        ],
        metadata: { containerId: "2", containerNumber: "TCLU1234568", documentId: "11", documentType: "waybill" },
    },

    // SHIPPER — Nuova richiesta ordine da receiver
    {
        id: "a6",
        audience: "shipper",
        type: "new_order_request",
        title: "Nuova richiesta ordine da Global Partners Corp",
        description: "Richiesta ordine con target settimana 15/2024. Packing list richiesta con dettagli completi.",
        timestamp: daysAgo(2),
        isRead: false,
        actions: [
            { label: "Vedi dettaglio ordine", href: "/shipper/orders/1" },
        ],
        metadata: { orderId: "1", receiverId: "2", shipperId: "1" },
    },

    // FREIGHT FORWARDER — nuove attività
    {
        id: "ff1",
        audience: "freightForwarder",
        type: "status_update",
        title: "Tracking aggiornato: Booking #GLF-2045 confermato",
        description: "Il vettore Maersk ha confermato la partenza da Genova per il 14 Feb 2024.",
        timestamp: daysAgo(0),
        isRead: false,
        actions: [
            { label: "Apri quote", href: "/freight-forwarder/quotes/1" },
        ],
        metadata: {
            routeFrom: "Genova, IT",
            routeTo: "Shanghai, CN",
            shippingCompany: "Maersk",
        },
    },
    {
        id: "ff2",
        audience: "freightForwarder",
        type: "document_updated",
        title: "Nuovo documento: Lettera d'incarico firmata da Shipper",
        description: "La lettera per Global Logistics è stata caricata e richiede revisione.",
        timestamp: daysAgo(1),
        isRead: false,
        actions: [
            { label: "Apri documenti", href: "/freight-forwarder/quotes/1?tab=documents" },
        ],
    },
    {
        id: "ff3",
        audience: "freightForwarder",
        type: "customs_issue",
        title: "Dogana Singapore richiede informazioni aggiuntive",
        description: "Il porto di destinazione ha richiesto dettagli sul packing list per il container MSKU998877.",
        timestamp: daysAgo(2),
        isRead: true,
        actions: [
            { label: "Gestisci richiesta", href: "/freight-forwarder/quotes" },
        ],
        metadata: {
            containerNumber: "MSKU998877",
        },
    },
];

// In-memory storage per activities dinamiche
let activities = [...mockActivities];

export const activityService = {
    getAll: () => [...activities],
    getByAudience: (audience: ActivityAudience) => activities.filter((a) => a.audience === audience),
    
    // Aggiungi nuova activity (per ordini creati dinamicamente)
    add: (activity: ActivityItem) => {
        activities.unshift(activity); // Aggiungi all'inizio
        return activity;
    },
    
    // Marca activity come letta
    markAsRead: (id: string) => {
        const activity = activities.find(a => a.id === id);
        if (activity) {
            activity.isRead = true;
        }
    },
};


